import React, { useState, useEffect, useContext, createContext } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
  Divider,
  Avatar,
  Tooltip,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getApiCall, postApiCall } from 'api/apiService';
import {
  API_URL,
  APPROVE_FILE,
  GET_INDIVIDUAL_FILE_MANAGER,
} from 'constant/app.config';
import { styles } from './DocumentHub';
import DocumentView from './DocumentView';
import { Tick } from 'component/BuyersMarketplace/Marketplaceicons';
import Swal from 'sweetalert2';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';
import Loading from 'assets/images/loading.png';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import { border } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';

const DocumentHistory = ({
  isDialog,
  address,
  onBackClick,
  onViewClick,
  onDownloadClick,
  propertyId,
  buyerId,
  userType,
  fileType,
  isFromVendorSolicitor,
  isFromBuyerSolicitor,
  isDirectBuyerDocumentHistory,
  backToContract,
  fileTypeCode,
  refreshTrigger,
  fileId,
  getListInfo,
}) => {
  const getTrimmedFileType = (fileType) => {
    if (!fileType) return '';

    const lastDashIndex = fileType.lastIndexOf('-');

    return lastDashIndex !== -1
      ? fileType.substring(0, lastDashIndex).trim()
      : fileType;
  };
  const trimmedFileType = getTrimmedFileType(fileType);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentVersion, setCurrentVersion] = useState(null);
  const [previousVersions, setPreviousVersions] = useState([]);
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');
  const context = useContext(datacontext);
  const contextt = useContext(datacontextsoli);
  const realTimeLog = context?.realTimeLog ?? contextt?.realTimeLog;
  const matches430 = window.innerWidth < 430;
  const [approving, setApproving] = useState(false);

  const CircularProgressWithProfileVendor = (props) => {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          width: 43,
          height: 43,
        }}
      >
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          {props.profileImage == '' || props.profileImage == null ? (
            <Avatar
              style={{
                width: '36px',
                height: '36px',
                fontFamily: 'poppins',
                fontSize: '15px',
                backgroundColor: '#666666',
              }}
            >
              {props?.name}
            </Avatar>
          ) : (
            <Avatar
              alt={props?.name}
              src={props.profileImage}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          )}
        </Box>
      </Box>
    );
  };

  const getStatusChip = (status) => {
    if (!status) return null;
    const statusStyles = {
      Signed: {
        color: '#8B27A7',
        bg: '#EAD6F5',
      },
      Pending: {
        color: '#92400E',
        bg: '#F5E6C8',
      },
      Approved: {
        color: '#065F46',
        bg: '#D7F2E3',
      },
      Superseded: {
        color: '#4B5563',
        bg: '#D1D5DB',
      },
      Default: {
        color: '#4B5563',
        bg: '#D1D5DB',
      },
    };

    const current = statusStyles[status] || statusStyles.Default;

    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3px 16px',
          borderRadius: '5px',
          fontSize: matches430 ? '14px' : '16px',
          fontFamily: 'Poppins',
          fontWeight: 500,
          lineHeight: '20px',
          color: current.color,
          backgroundColor: current.bg,
          marginLeft: '0',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {status}
      </Box>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';

    const date = new Date(dateString.replace(' ', 'T'));

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${hours}:${minutes}:${seconds} ${day}-${month}-${year}`;
  };

  const fetchIndividualFileManager = async (showLoader = true) => {
    if (!propertyId || !fileType) {
      setLoading(false);
      return;
    }
    // setLoading(true);
    if (showLoader) {
      setLoading(true);
    }
    setError(null);

    try {
      const payload = {
        propertyId: propertyId,
        buyerId: buyerId ? buyerId : 0,
        userType: userType,
        fileType: trimmedFileType,
        fileTypeCode: fileTypeCode,
      };

      const response = await getApiCall(GET_INDIVIDUAL_FILE_MANAGER, payload);
      const apiData = response?.data;

      if (apiData?.status === 1 && apiData?.files && apiData.files.length > 0) {
        const files = apiData.files;

        const mappedFiles = files.map((file) => ({
          versionNumber: file.version,
          label: file.status === 'Signed' ? `Signed by ${file.updatedAs}` : '',
          uploadDate: formatDate(file.fileCreatedAt),
          uploadedBy: file.updatedAs,
          status: file.status
            ? file.status.charAt(0).toUpperCase() +
              file.status.slice(1).toLowerCase()
            : null,
          fileId: file.fileId,
          filePath: file.filePath,
          updatedBy: file.updatedBy,
          fileType: trimmedFileType,
          fullFileType: file.fileType,
          updatedByName: file.updatedByName,
          updatedAs: file.updatedAs,
          description: file.description,
          approvedByName: file?.approvedByName,
          approvedAt: file?.approvedAt,
          updatedByProfile: file?.updatedByProfile,
          approvedByProfile: file?.approvedByProfile,
          fileCreatedAt: file?.fileCreatedAt,
          activityStatus: file?.activityStatus,
          activityAs: file?.activityAs,
          updatedByNameInitial: file.updatedByNameInitial,
          approvedByNameInitial: file?.approvedByNameInitial,
        }));

        if (mappedFiles.length > 0) {
          setCurrentVersion(mappedFiles[0]);
          setPreviousVersions(mappedFiles.slice(1));
        } else {
          setCurrentVersion(null);
          setPreviousVersions([]);
        }
      } else {
        setCurrentVersion(null);
        setPreviousVersions([]);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      setError('Failed to fetch document history');
      setCurrentVersion(null);
      setPreviousVersions([]);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (propertyId && fileType) {
      fetchIndividualFileManager(true);
    } else {
      setLoading(false);
    }
  }, [propertyId, buyerId, userType, fileType, isDialog]);
  useEffect(() => {
    if (realTimeLog) {
      fetchIndividualFileManager(false);
      if (getListInfo) {
        getListInfo();
      }
    }
  }, [realTimeLog]);

  useEffect(() => {
    if (propertyId && fileType) {
      fetchIndividualFileManager();
    }
  }, [refreshTrigger]);

  const isPdf = (filePath) => {
    return filePath?.toLowerCase().includes('.pdf');
  };

  const isDownloadableFile = (filePath) => {
    if (!filePath) return false;

    const lowerPath = filePath.toLowerCase();

    return (
      lowerPath.includes('.pdf') ||
      lowerPath.includes('.jpg') ||
      lowerPath.includes('.jpeg') ||
      lowerPath.includes('.png')
    );
  };

  const normalizeUrl = (url) => {
    if (!url) return '';

    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }

    return `https://${url}`;
  };

  const handleViewClick = (versionNumber, fileId, filePath, documentType) => {
    if (isPdf(filePath)) {
      setSelectedPdfUrl(filePath);
      setSelectedFileName(
        `Version ${versionNumber} - ${documentType || 'Document'}`
      );
      setPdfViewerOpen(true);
    } else {
      window.open(normalizeUrl(filePath), '_blank');
    }

    if (onViewClick) {
      onViewClick(versionNumber, fileId, filePath);
    }
  };

  const getFileExtension = (filePath) => {
    return filePath.split('.').pop().split('?')[0];
  };

  const handleDownload = async (versionNumber, fileId, filePath) => {
    try {
      const response = await fetch(filePath);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const extension = getFileExtension(filePath);

      link.download = `Version_${versionNumber}_${
        fileType || 'Document'
      }.${extension}`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      if (onDownloadClick) {
        onDownloadClick(versionNumber, fileId, filePath);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const ActionButtons = ({ versionNumber, fileId, filePath }) => (
    <Stack direction="row" spacing={1} sx={{ marginTop: '10px' }}>
      <Button
        variant="contained"
        size="small"
        onClick={() => handleViewClick(versionNumber, fileId, filePath)}
        sx={{
          backgroundColor: '#4AADE5',
          color: '#fff',
          textTransform: 'none',
          fontFamily: 'Poppins',
          fontWeight: 500,
          fontSize: '12px',
          borderRadius: '4px',
          padding: '4px 20px',
          minWidth: 'unset',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#3898d1',
            boxShadow: 'none',
          },
        }}
      >
        View
      </Button>

      {isDownloadableFile(filePath) && (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleDownload(versionNumber, fileId, filePath)}
          sx={{
            backgroundColor: '#8E8E8E',
            color: '#fff',
            textTransform: 'none',
            fontFamily: 'Poppins',
            fontWeight: 500,
            fontSize: '12px',
            borderRadius: '4px',
            padding: '4px 14px',
            minWidth: 'unset',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#757575',
              boxShadow: 'none',
            },
          }}
        >
          Download
        </Button>
      )}
    </Stack>
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px',
        }}
      >
        <img
          alt="Loading"
          src={Loading}
          className="loaderImage"
          style={{
            height: '50px',
            width: '50px',
          }}
        />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '400px',
        }}
      >
        <Typography sx={{ fontFamily: 'Poppins', color: 'error.main' }}>
          {error}
        </Typography>
      </Box>
    );
  }

  const handleApproveFile = async () => {
    if (approving) return;
    setApproving(true);
    try {
      const payload = {
        fileId: fileId,
        userType: isFromBuyerSolicitor ? 'Buyer Solicitor' : 'Vendor Solicitor',
      };

      const response = await postApiCall(APPROVE_FILE, payload);

      if (response?.data?.status === 1) {
        await Swal.fire({
          title: response?.data?.heading || 'Success',
          text: response?.data?.message || 'File approved successfully',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });

        fetchIndividualFileManager();
      } else {
        await Swal.fire({
          title: response?.data?.heading || 'Error',
          text: response?.data?.message || 'Approval failed',
          icon: 'error',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: 'Something went wrong',
        icon: 'error',
        confirmButtonText: 'Close',
        confirmButtonColor: '#4CA4D6',
      });
    } finally {
      setApproving(false);
    }
  };
  const getTrimmedFileTypeForHeading = (fileType) => {
    if (!fileType) return '';

    if (fileType.toLowerCase().includes('acceptance certificate')) {
      return fileType.split('-')[0].trim();
    }

    return fileType;
  };

  const columnWidths = {
    version: 80,
    activity: 160,
    uploadedBy: 220,
    approvedBy: 220,
    status: 170,
    documentType: 170,
    description: 300,
    action: 120,
  };

  return (
    <>
      <Box
        sx={{
          width: '100%',
          fontFamily: 'Poppins',
          backgroundColor: '#F9FAFB',
          px: 2,
        }}
      >
        {/* BACK */}
        {!isDirectBuyerDocumentHistory && (
          <Stack
            direction="row"
            onClick={onBackClick}
            sx={{ mb: 2, cursor: 'pointer' }}
          >
            <ChevronLeftIcon />
            <Typography sx={{ ...poppins500, fontSize: '16px' }}>
              Back to Documents
            </Typography>
          </Stack>
        )}

        {isDirectBuyerDocumentHistory && (
          <Stack
            direction="row"
            onClick={backToContract}
            sx={{ mb: 2, cursor: 'pointer' }}
          >
            <ArrowBackIcon sx={styles.backIcon} />
            <Typography sx={styles.backText}>Back to Previous</Typography>
          </Stack>
        )}

        {/* NO DATA */}
        {!currentVersion && !loading ? (
          <Box sx={{ textAlign: 'center', mt: 5 }}>
            <Typography sx={{ fontFamily: 'Poppins', color: '#666666' }}>
              Files not found
            </Typography>
          </Box>
        ) : (
          currentVersion && (
            <>
              {/* ================= CURRENT VERSION ================= */}
              <Box marginBottom={2}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: '20px',
                    color: '#000000',
                  }}
                >
                  {getTrimmedFileTypeForHeading(fileType)}
                </Typography>
              </Box>

              <Box
                display={'flex'}
                alignItems="center"
                justifyContent="space-between"
                mb={2}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: matches430 ? '14px' : '16px',
                    color: '#000000',
                  }}
                >
                  Current Version
                </Typography>

                {isFromBuyerSolicitor &&
                  isDirectBuyerDocumentHistory &&
                  currentVersion?.status === 'Pending' && (
                    <Box display="flex" alignItems="center" gap="8px">
                      <Button
                        sx={{
                          padding: '6px 16px',
                          border: '1px solid #34C759',
                          fontFamily: 'Poppins',
                          color: '#FFFFFF',
                          backgroundColor: '#34C759',
                          fontWeight: 400,
                          fontSize: '13px',
                          borderRadius: '5px',
                          textTransform: 'none',
                          minWidth: '90px',
                          height: '30px',
                          '&:hover': {
                            border: '1px solid #34C759',
                            color: '#FFFFFF',
                            backgroundColor: '#34C759',
                            boxShadow: 'none',
                          },
                        }}
                        disableElevation
                        disableRipple
                        variant="contained"
                        disabled={approving}
                        startIcon={
                          <Tick color={approving ? '#BDBDBD' : '#FFFFFF'} />
                        }
                        onClick={handleApproveFile}
                      >
                        Approve
                      </Button>

                      {approving && (
                        <img
                          alt="Loading"
                          src={Loading}
                          className="loaderImage"
                          style={{
                            height: '20px',
                            width: '20px',
                          }}
                        />
                      )}
                    </Box>
                  )}
              </Box>

              <TableContainer
                component={Paper}
                sx={{
                  mb: 3,
                  width: '100%',
                  overflowX: 'auto',
                }}
              >
                <Table
                  sx={{
                    minWidth: 1300,
                    tableLayout: 'fixed',
                  }}
                >
                  {/* ---------------- HEADER ---------------- */}
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#F1F5F9' }}>
                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.version }}
                      >
                        Version
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.activity }}
                      >
                        Activity
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.uploadedBy }}
                      >
                        Uploaded By
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.approvedBy }}
                      >
                        Approved By
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.status }}
                      >
                        Document Status
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.documentType }}
                      >
                        Document Type
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.description }}
                      >
                        Description
                      </TableCell>

                      <TableCell
                        sx={{ ...poppins600, width: columnWidths.action }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* ---------------- BODY ---------------- */}
                  <TableBody>
                    <TableRow>
                      {(() => {
                        const userCellWrapper = {
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          gap: '2px',
                        };

                        const userRow = {
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          minHeight: '50px',
                        };

                        const nameText = {
                          ...poppins500,
                          fontSize: '14px',
                          lineHeight: 1.2,
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '140px',
                        };

                        const subText = {
                          ...poppins400,
                          fontSize: '13px',
                          color: '#64748B',
                          lineHeight: 1.2,
                          whiteSpace: 'normal',
                          wordBreak: 'break-word',
                        };

                        return (
                          <>
                            {/* VERSION */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 80 }}
                            >
                              <Typography sx={nameText}>
                                {currentVersion.versionNumber}
                              </Typography>
                            </TableCell>

                            {/* ACTIVITY */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 140 }}
                            >
                              <Box sx={userCellWrapper}>
                                <Typography sx={nameText}>
                                  {currentVersion.activityStatus}
                                </Typography>
                                <Typography sx={subText}>
                                  {currentVersion.activityAs}
                                </Typography>
                              </Box>
                            </TableCell>

                            {/* UPLOADED BY */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 180 }}
                            >
                              <Box sx={userCellWrapper}>
                                <Box sx={userRow}>
                                  <CircularProgressWithProfileVendor
                                    value={''}
                                    name={currentVersion?.updatedByNameInitial}
                                    profileImage={
                                      currentVersion.updatedByProfile || ''
                                    }
                                  />
                                  <Typography sx={nameText}>
                                    {currentVersion.updatedByName}
                                  </Typography>
                                </Box>

                                <Typography sx={subText}>
                                  {currentVersion.uploadDate}
                                </Typography>
                              </Box>
                            </TableCell>

                            {/* APPROVED BY */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 180 }}
                            >
                              {currentVersion?.approvedByName ? (
                                <Box sx={userCellWrapper}>
                                  <Box sx={userRow}>
                                    <CircularProgressWithProfileVendor
                                      value={''}
                                      name={
                                        currentVersion?.approvedByNameInitial
                                      }
                                      profileImage={
                                        currentVersion.approvedByProfile || ''
                                      }
                                    />

                                    <Typography sx={nameText}>
                                      {currentVersion.approvedByName}
                                    </Typography>
                                  </Box>

                                  <Typography sx={subText}>
                                    {currentVersion?.approvedAt
                                      ? formatDate(currentVersion.approvedAt)
                                      : '-'}
                                  </Typography>
                                </Box>
                              ) : (
                                <Typography sx={nameText}>-</Typography>
                              )}
                            </TableCell>

                            {/* STATUS */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 150 }}
                            >
                              {currentVersion.status ? (
                                getStatusChip(currentVersion.status)
                              ) : (
                                <Typography sx={nameText}>-</Typography>
                              )}
                            </TableCell>

                            {/* DOCUMENT TYPE */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 150 }}
                            >
                              {currentVersion?.fullFileType ? (
                                <Typography sx={nameText}>
                                  {currentVersion.fullFileType.startsWith(
                                    'Acceptance Certificate'
                                  )
                                    ? currentVersion.fullFileType
                                    : currentVersion.fullFileType.split(
                                        ' - '
                                      )[0]}
                                </Typography>
                              ) : (
                                <Typography sx={nameText}>-</Typography>
                              )}
                            </TableCell>

                            {/* DESCRIPTION */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 220 }}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '14px',
                                  wordBreak: 'break-word',
                                }}
                              >
                                {currentVersion.description || '-'}
                              </Typography>
                            </TableCell>

                            {/* ACTION */}
                            <TableCell
                              sx={{ padding: '8px 16px', minWidth: 120 }}
                            >
                              <Tooltip
                                title="View"
                                arrow
                                placement="top"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontFamily: 'Poppins',
                                      fontSize: '12px',
                                      fontWeight: 400,
                                    },
                                  },
                                }}
                                PopperProps={{
                                  disablePortal: false,
                                  sx: {
                                    zIndex: 1500,
                                  },
                                }}
                              >
                                <IconButton
                                  sx={{
                                    color: 'inherit',
                                    '&:hover': {
                                      color: '#1976d2',
                                    },
                                  }}
                                  onClick={() =>
                                    handleViewClick(
                                      currentVersion.versionNumber,
                                      currentVersion.fileId,
                                      currentVersion.filePath,
                                      currentVersion.fullFileType.startsWith(
                                        'Acceptance Certificate'
                                      )
                                        ? currentVersion.fullFileType
                                        : currentVersion.fullFileType.split(
                                            ' - '
                                          )[0]
                                    )
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              </Tooltip>

                              {isDownloadableFile(currentVersion.filePath) && (
                                <Tooltip
                                  title="Download"
                                  arrow
                                  placement="top"
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                      },
                                    },
                                  }}
                                  PopperProps={{
                                    disablePortal: false,
                                    sx: {
                                      zIndex: 1500,
                                    },
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      color: 'inherit',
                                      '&:hover': {
                                        color: '#1976d2',
                                      },
                                    }}
                                    onClick={() =>
                                      handleDownload(
                                        currentVersion.versionNumber,
                                        currentVersion.fileId,
                                        currentVersion.filePath
                                      )
                                    }
                                  >
                                    <DownloadIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </TableCell>
                          </>
                        );
                      })()}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              {/* ================= PREVIOUS VERSIONS ================= */}
              {previousVersions.length > 0 && (
                <>
                  <Box mb={2}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontWeight: 600,
                        fontSize: matches430 ? '14px' : '16px',
                        color: '#000000',
                      }}
                    >
                      {previousVersions?.length === 1
                        ? 'Previous Version'
                        : 'Previous Versions'}
                    </Typography>
                  </Box>
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: '100%',
                      overflowX: 'auto', // ✅ horizontal scroll
                    }}
                  >
                    <Table
                      sx={{
                        minWidth: 1300, // ✅ prevents collapsing
                        tableLayout: 'fixed',
                      }}
                    >
                      {/* ---------------- HEADER ---------------- */}
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#F1F5F9' }}>
                          <TableCell
                            sx={{ ...poppins600, width: columnWidths.version }}
                          >
                            Version
                          </TableCell>

                          <TableCell
                            sx={{ ...poppins600, width: columnWidths.activity }}
                          >
                            Activity
                          </TableCell>

                          <TableCell
                            sx={{
                              ...poppins600,
                              width: columnWidths.uploadedBy,
                            }}
                          >
                            Uploaded By
                          </TableCell>

                          <TableCell
                            sx={{
                              ...poppins600,
                              width: columnWidths.approvedBy,
                            }}
                          >
                            Approved By
                          </TableCell>

                          <TableCell
                            sx={{ ...poppins600, width: columnWidths.status }}
                          >
                            Document Status
                          </TableCell>

                          <TableCell
                            sx={{
                              ...poppins600,
                              width: columnWidths.documentType,
                            }}
                          >
                            Document Type
                          </TableCell>

                          <TableCell
                            sx={{
                              ...poppins600,
                              width: columnWidths.description,
                            }}
                          >
                            Description
                          </TableCell>

                          <TableCell
                            sx={{ ...poppins600, width: columnWidths.action }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      {/* ---------------- BODY ---------------- */}
                      <TableBody>
                        {previousVersions.map((version, index) => {
                          const userCellWrapper = {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            gap: '2px',
                          };

                          const userRow = {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            minHeight: '50px',
                          };

                          const nameText = {
                            ...poppins500,
                            fontSize: '14px',
                            lineHeight: 1.2,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            maxWidth: '140px',
                          };

                          const subText = {
                            ...poppins400,
                            fontSize: '13px',
                            color: '#64748B',
                            lineHeight: 1.2,
                            whiteSpace: 'normal', // ✅ was nowrap
                            wordBreak: 'break-word',
                          };

                          return (
                            <TableRow key={index}>
                              {/* VERSION */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 80 }}
                              >
                                <Typography sx={nameText}>
                                  {version.versionNumber}
                                </Typography>
                              </TableCell>

                              {/* ACTIVITY */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 140 }}
                              >
                                <Box sx={userCellWrapper}>
                                  <Typography sx={nameText}>
                                    {version.activityStatus}
                                  </Typography>
                                  <Typography sx={subText}>
                                    {version.activityAs}
                                  </Typography>
                                </Box>
                              </TableCell>

                              {/* UPLOADED BY */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 180 }}
                              >
                                {version.updatedByName ? (
                                  <Box sx={userCellWrapper}>
                                    <Box sx={userRow}>
                                      <CircularProgressWithProfileVendor
                                        value={''}
                                        name={version?.updatedByNameInitial}
                                        profileImage={
                                          version.updatedByProfile || ''
                                        }
                                      />
                                      <Typography sx={nameText}>
                                        {version.updatedByName}
                                      </Typography>
                                    </Box>

                                    <Typography sx={subText}>
                                      {version?.fileCreatedAt
                                        ? formatDate(version.fileCreatedAt)
                                        : '-'}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography sx={nameText}>-</Typography>
                                )}
                              </TableCell>

                              {/* APPROVED BY */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 180 }}
                              >
                                {version?.approvedByName ? (
                                  <Box sx={userCellWrapper}>
                                    <Box sx={userRow}>
                                      <CircularProgressWithProfileVendor
                                        value={''}
                                        name={version?.approvedByNameInitial}
                                        profileImage={
                                          version.approvedByProfile || ''
                                        }
                                      />

                                      <Typography sx={nameText}>
                                        {version.approvedByName}
                                      </Typography>
                                    </Box>

                                    <Typography sx={subText}>
                                      {version?.approvedAt
                                        ? formatDate(version.approvedAt)
                                        : '-'}
                                    </Typography>
                                  </Box>
                                ) : (
                                  <Typography sx={nameText}>-</Typography>
                                )}
                              </TableCell>

                              {/* STATUS */}
                              <TableCell
                                sx={{
                                  padding: '8px 16px',
                                  minWidth: 150,
                                  textAlign: 'left',
                                }}
                              >
                                {version.status ? (
                                  getStatusChip(version.status)
                                ) : (
                                  <Typography sx={nameText}>-</Typography>
                                )}
                              </TableCell>

                              {/* DOUCMENT TYPE */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 150 }}
                              >
                                <Typography sx={nameText}>
                                  {version?.fullFileType
                                    ? version.fullFileType.startsWith(
                                        'Acceptance Certificate'
                                      )
                                      ? version.fullFileType
                                      : version.fullFileType.split(' - ')[0]
                                    : '-'}
                                </Typography>
                              </TableCell>

                              {/* DESCRIPTION */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 220 }}
                              >
                                <Typography
                                  sx={{
                                    ...poppins400,
                                    fontSize: '14px',
                                    wordBreak: 'break-word',
                                  }}
                                >
                                  {version.description || '-'}
                                </Typography>
                              </TableCell>

                              {/* ACTION */}
                              <TableCell
                                sx={{ padding: '8px 16px', minWidth: 120 }}
                              >
                                <Tooltip
                                  title="View"
                                  arrow
                                  placement="top"
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        fontFamily: 'Poppins',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                      },
                                    },
                                  }}
                                  PopperProps={{
                                    disablePortal: false,
                                    sx: {
                                      zIndex: 1500,
                                    },
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      color: 'inherit',
                                      '&:hover': {
                                        color: '#1976d2',
                                      },
                                    }}
                                    onClick={() =>
                                      handleViewClick(
                                        version.versionNumber,
                                        version.fileId,
                                        version.filePath,
                                        version?.fullFileType
                                          ? version.fullFileType.startsWith(
                                              'Acceptance Certificate'
                                            )
                                            ? version.fullFileType
                                            : version.fullFileType.split(
                                                ' - '
                                              )[0]
                                          : '-'
                                      )
                                    }
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>

                                {isDownloadableFile(version.filePath) && (
                                  <Tooltip
                                    title="Download"
                                    arrow
                                    placement="top"
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          fontFamily: 'Poppins',
                                          fontSize: '12px',
                                          fontWeight: 400,
                                        },
                                      },
                                    }}
                                    PopperProps={{
                                      disablePortal: false,
                                      sx: {
                                        zIndex: 1500,
                                      },
                                    }}
                                  >
                                    <IconButton
                                      sx={{
                                        color: 'inherit',
                                        '&:hover': {
                                          color: '#1976d2',
                                        },
                                      }}
                                      onClick={() =>
                                        handleDownload(
                                          version.versionNumber,
                                          version.fileId,
                                          version.filePath
                                        )
                                      }
                                    >
                                      <DownloadIcon />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </>
          )
        )}
      </Box>

      <DocumentView
        open={pdfViewerOpen}
        onClose={() => setPdfViewerOpen(false)}
        fileUrl={selectedPdfUrl}
        fileName={selectedFileName}
      />
    </>
  );
};

export default DocumentHistory;
